<template>
  <div class="selector-container pa-3">
    <ViewBySelector
      v-model:selectedViewBy="selectedViewByLocal"
      v-if="!singleLocation"
    />
    <ScopeSelector
      :selectedViewBy="selectedViewByLocal"
      v-model:selectedScopes="selectedScopesLocal"
      :singleSelect="singleLocation"
      :onlyActiveLocations="onlyActiveLocations"
    />
    <UpdateButton
      :selectedViewByLocal="selectedViewByLocal"
      :selectedScopesLocal="selectedScopesLocal"
      @update="update"
    />
  </div>
</template>

<script setup>
import { ref, watch, toRefs, onMounted } from "vue";
import { useRootStore } from "../../../../stores/root";
import { storeToRefs } from "pinia";
import ViewBySelector from "./ViewBySelector.vue";
import ScopeSelector from "./ScopeSelector.vue";
import UpdateButton from "./UpdateButton.vue";

const props = defineProps({
  singleLocation: {
    type: Boolean,
    default: false,
  },
  onlyActiveLocations: {
    type: Boolean,
    default: true,
  },
});

const { singleLocation, onlyActiveLocations } = toRefs(props);

const store = useRootStore();
const { selectedScopes, selectedViewBy } = storeToRefs(store);

const selectedScopesLocal = ref([...selectedScopes.value]);
const selectedViewByLocal = ref(selectedViewBy.value);

function update() {
  selectedScopes.value = [...selectedScopesLocal.value];
  selectedViewBy.value = selectedViewByLocal.value;
}

watch(selectedScopes, () => {
  selectedScopesLocal.value = [...selectedScopes.value];
});

watch(singleLocation, () => {
  if (singleLocation.value) {
    selectedViewBy.value = "locations";
    selectedViewByLocal.value = "locations";
  }
});

onMounted(() => {
  if (onlyActiveLocations.value === true) {
    selectedScopes.value = selectedScopes.value.filter(scope => scope.isActive);
  }
});
</script>

<style scoped>
.selector-container {
  display: flex;
  gap: 5px;
  align-items: center;
}
</style>